import { isProduction } from 'utils/env'

export const rootPath = isProduction
  ? 'https://www.creativefabrica.com'
  : 'https://staging.creativefabrica.com'
